import React from 'react';

import Badge from 'components/Badge';

interface IProps {
  stringDate: string;
}

const StoryBadges = ({ stringDate }: IProps): React.ReactElement => {
  const fourteenDaysAgo = new Date();

  fourteenDaysAgo.setDate(fourteenDaysAgo.getDate() - 14);

  const isNew = new Date(stringDate).getTime() > fourteenDaysAgo.getTime();

  if (isNew) {
    return <Badge variant="new" />;
  }
  return <></>;
};

export default StoryBadges;
